import { render } from "./NavBarPlantilles.vue?vue&type=template&id=63cc765f"
import script from "./NavBarPlantilles.vue?vue&type=script&lang=js"
export * from "./NavBarPlantilles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__